import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Text, VStack } from "native-base";
import { useEffect } from "react";
import { useTranslation } from "@madmedical/i18n";
import SubmitButton from "../../form/SubmitButton";
import DateInput from "../../form/DateInput";
import Button from "../../atoms/Button";
import ModalContent from "../../molecules/ModalContent";
import FormControl from "../../form/FormControl";
const CalculateBirthTimeModal = ({ onClose, onSubmitPress, isSuccess, }) => {
    useEffect(() => {
        if (isSuccess) {
            onClose();
        }
    }, [isSuccess, onClose]);
    const { t } = useTranslation();
    return (_jsx(ModalContent, Object.assign({ header: `Kisbabád várható születése`, footer: _jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onPress: onClose, variant: "outlined" }, { children: t("cancel") })), _jsx(SubmitButton, { onPress: onSubmitPress, label: "Sz\u00E1mol\u00E1s" })] }) }, { children: _jsxs(VStack, { children: [_jsx(DateInput, { name: "lastMenstruationDate", isRequired: true, label: "Utols\u00F3 menstru\u00E1ci\u00F3d els\u0151 napja" }), _jsx(Box, Object.assign({ mt: 6 }, { children: _jsx(FormControl, { label: "Menstru\u00E1ci\u00F3s ciklusod hossza", name: "menstruationCycleLength", labelProps: {
                            _text: { color: "gray.600" },
                        }, type: "number", height: "44px", maxLength: 2, InputRightElement: _jsx(Box, Object.assign({ px: 2 }, { children: _jsx(Text, Object.assign({ color: "gray.500", fontSize: "xs" }, { children: "Nap" })) })) }) }))] }) })));
};
export default CalculateBirthTimeModal;
